<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
  <g>
    <g>
      <g>
        <rect class="cls-2" x="24" y="39.6" width="14.95" height="4.83" rx="1.5" ry="1.5"/>
        <path class="cls-2" d="M23.9,49.16l-9.73-5.62c-1.18-.68-1.18-2.37,0-3.05l9.73-5.62c1.18-.68,2.64,.17,2.64,1.53v11.24c0,1.36-1.47,2.21-2.64,1.53Z"/>
      </g>
      <g>
        <rect class="cls-2" x="51.12" y="39.6" width="14.95" height="4.83" rx="1.5" ry="1.5"/>
        <path class="cls-2" d="M66.17,34.87l9.73,5.62c1.18,.68,1.18,2.37,0,3.05l-9.73,5.62c-1.18,.68-2.64-.17-2.64-1.53v-11.24c0-1.36,1.47-2.21,2.64-1.53Z"/>
      </g>
    </g>
    <g>
      <g>
        <rect class="cls-2" x="42.62" y="48.1" width="4.83" height="14.95" rx="1.5" ry="1.5"/>
        <path class="cls-2" d="M52.18,63.16l-5.62,9.73c-.68,1.18-2.37,1.18-3.05,0l-5.62-9.73c-.68-1.18,.17-2.64,1.53-2.64h11.24c1.36,0,2.21,1.47,1.53,2.64Z"/>
      </g>
      <g>
        <rect class="cls-2" x="42.62" y="20.98" width="4.83" height="14.95" rx="1.5" ry="1.5"/>
        <path class="cls-2" d="M37.89,20.88l5.62-9.73c.68-1.18,2.37-1.18,3.05,0l5.62,9.73c.68,1.18-.17,2.64-1.53,2.64h-11.24c-1.36,0-2.21-1.47-1.53-2.64Z"/>
      </g>
    </g>
    <polyline class="cls-3" points="33.53 71.52 33.53 79.81 56.54 79.81 56.54 71.52"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "MovementDownloadIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: none;
    stroke: #0f5b71;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3.5px;
  }
</style>
